/// Minimal interface that only includes what we need
interface WindowWithKustomerGetNonce extends Window {
  KustomerGetNonce?: (
    scriptEmbedElement?: HTMLScriptElement | null,
  ) => string | undefined;
}

/**
 * URLs that are allowed to receive CSP nonces when applying nonce to dynamic scripts.
 * These are trusted domains that are safe to apply CSP nonces to.
 */
export const CSP_NONCE_ALLOWED_URLS = [
  'https://cdn.kustomerapp.com',
  'https://cdn.helpapp.io',
  'http://localhost:9000'
];

/**
 * Main function to get the nonce from script tags
 *
 * This function looks for nonce attributes in script tags that load the Kustomer SDK.
 * It now only looks for script tags with `data-kustomer-api-key` attribute,
 * as all entry points (widget.js, core.js, widget_api) now include this attribute.
 *
 * The function prioritizes the passed scriptEmbedElement parameter, then falls back
 * to searching the DOM for the appropriate script tag.
 *
 * @param scriptEmbedElement - Optional script element to check for nonce
 * @returns The nonce value if found, undefined otherwise
 */
export const getNonce = (scriptEmbedElement?: HTMLScriptElement | null): string | undefined => {
  // First try the passed script element, then search DOM for [data-kustomer-api-key] script tag
  const embedElement = scriptEmbedElement || document.querySelector(
    '[data-kustomer-api-key]',
  ) as HTMLScriptElement | null;

  const nonce = embedElement?.getAttribute('nonce') || undefined;
  return nonce;
};

// Add to window for browser-side files to use without imports
if (typeof window !== 'undefined') {
  (window as WindowWithKustomerGetNonce).KustomerGetNonce = getNonce;
}
